import React from 'react';
import ShowFiscal from '../FiscaisVinculados/ShowFiscal';

export default function ShowAvaliador() {
  return <ShowFiscal evaluator />;
}
